import { render, staticRenderFns } from "./DashboardSidebard.vue?vue&type=template&id=59571839"
import script from "./DashboardSidebard.vue?vue&type=script&lang=js"
export * from "./DashboardSidebard.vue?vue&type=script&lang=js"
import style0 from "./DashboardSidebard.vue?vue&type=style&index=0&id=59571839&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports